module.exports = __webpack_public_path__ + "images/boxes/studio_09-20ae67bc0b32eeffcf332f983c869807.webp";